import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectEditBillingShiftDifferentialRows,
  selectEditPayrollShiftDifferentialRows,
  selectShiftDifferentialEndTimeError,
} from 'store/redux-store/placement-mods/selectors';
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { TextField } from '@mui/material';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { Controller, useFormContext } from 'react-hook-form';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import moment from 'moment';
import { makeStyles } from 'tss-react/mui';
import { isNullOrUndefined } from 'app/helpers/objectHelpers';
import { missingField } from 'app/constants';
import { findIndex, findRow } from '../Utils';
import { modsEnums } from 'app/models/Placement/PlacementMods';

interface GridCellProps {
  [key: string]: any;
}

const useStyles = makeStyles()(() => ({
  inputFields: {
    '& .MuiInputBase-root.MuiFilledInput-root': {
      backgroundColor: 'white !important;',
    },
  },
}));

export const EditEndTimeCell = (props: any) => {
  return <EditEndTime cellParams={props?.cellParams} currentMod={props?.currentMod} />;
};

const EditEndTime = React.memo(function EditEndTime(params: GridCellProps) {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const { control } = useFormContext();
  const rowId = params?.cellParams?.id;
  const currentValue = params?.cellParams?.value;
  const [endTimeValue, setEndTimeValue] = useState(currentValue);
  const shiftDiffEditRequests =
    params?.currentMod === modsEnums.PayrollShiftDifferential
      ? useSelector(selectEditPayrollShiftDifferentialRows)
      : useSelector(selectEditBillingShiftDifferentialRows);
  const endTimeErrors = useSelector(selectShiftDifferentialEndTimeError);

  useEffect(() => {
    const date = moment(endTimeValue);
    if (!date.isValid() && !isNullOrUndefined(endTimeValue) && endTimeValue != missingField) {
      setEndTimeValue(moment(endTimeValue, 'hh:mm a'));
    }
  }, [endTimeValue]);

  useEffect(() => {
    if (params?.cellParams?.error !== null && params?.cellParams?.error !== undefined) {
      const val = endTimeErrors?.filter(el => el.id === params?.cellParams?.id);

      const arr = endTimeErrors?.length > 0 ? endTimeErrors?.slice(0) : [];
      if (val?.length === 0) {
        const valueObj = { endTime: params?.cellParams?.error, id: params?.cellParams?.id };
        arr.push(valueObj);
      } else {
        const currentObj = arr.find(val => val.id === params?.cellParams?.id);
        const updatedObj = { ...currentObj, endTime: params?.cellParams?.error };
        const editIndex = arr.findIndex(val => val.id === params?.cellParams?.id);

        arr[editIndex] = updatedObj;
      }

      dispatch(placementModsAction.setShiftDifferentialEndTimeError(arr));
    }
  }, [params?.cellParams?.error]);

  const setEndTimeForEdit = data => {
    let newRow = shiftDiffEditRequests.slice(0);
    const shiftDiffEditRow = findRow(params, shiftDiffEditRequests, rowId);
    const updatedCell = {
      ...shiftDiffEditRow,
      endTime: data,
    };

    const editDateIndex = findIndex(updatedCell, params, shiftDiffEditRequests, rowId);
    newRow[editDateIndex] = updatedCell;
    switch (params?.currentMod) {
      case modsEnums.PayrollShiftDifferential: {
        dispatch(placementModsAction.setEditPayrollShiftDiffRows(newRow));
        break;
      }
      case modsEnums.BillingShiftDifferential: {
        dispatch(placementModsAction.setEditBillingShiftDiffRows(newRow));
        break;
      }
    }
  };

  return (
    <>
      <Controller
        name={`shiftDiffRequests${rowId}.endTime`}
        control={control}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, value, ...rest } }) => (
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <TimePicker
              className={classes.inputFields}
              value={value || endTimeValue}
              views={['hours', 'minutes']}
              onChange={time => {
                const newDate = moment(time, 'hh:mm a', true);
                if (newDate.isValid() ) {
                  const setTo = moment(newDate).format('YYYY-MM-DDTHH:mm') 
                  setEndTimeValue(setTo);
                  setEndTimeForEdit(setTo);
                  onChange(setTo);
                  dispatch(placementModsAction.setCustomTemplateType(true));
                  dispatch(placementModsAction.setOriginCustomTemplateChanged(true));
                } else {
                  onChange(null);
                }
              }}
              renderInput={({ inputProps, ...restParams }) => (
                <>
                  <TextField
                    {...restParams}
                    fullWidth
                    id={`input${rowId}.endTime`}
                    aria-label="change time"
                    value={endTimeValue}
                    variant="filled"
                    inputProps={{
                      ...inputProps,
                      autoComplete: 'off',
                      placeholder: 'hh:mm am|pm',
                      style: { paddingTop: '4px', height: '2rem' },
                    }}
                  />
                </>
              )}
            />
          </LocalizationProvider>
        )}
      />
    </>
  );
});
